export type SearchParamsState = {
  [key: string]: string;
};

export const searchParamsToState = (searchParams: URLSearchParams) => {
  const state: SearchParamsState = {};
  for (const [key, value] of searchParams.entries()) {
    state[key] = value;
  }
  return state;
};

export const stateToSearchParams = (
  state: SearchParamsState
): URLSearchParams => {
  const searchParams = new URLSearchParams();
  if (!state) {
    return searchParams;
  }
  for (const [key, value] of Object.entries(state)) {
    searchParams.append(key, value);
  }
  return searchParams;
};
